import { useQuery } from '@tanstack/react-query'
import { api } from '@/services/api'
import { RapidApiUsageResponse } from '@/types'
import type { AnalyticsPeriod } from './useAnalytics'

const RAPIDAPI_QUERY_KEY = 'rapidapi-usage'

export const useRapidApiUsage = (period: AnalyticsPeriod = '30d') => {
  return useQuery<RapidApiUsageResponse>({
    queryKey: [RAPIDAPI_QUERY_KEY, period],
    queryFn: async () => {
      const { data } = await api.get(`/analytics/rapidapi-usage?period=${period}`)
      return data
    },
    refetchInterval: 5 * 60 * 1000,
  })
}
